import {createContext} from 'react';

import {Url} from './url';

export const UrlContext = createContext<Url>(new Url('shop1.myshopify.io'));
